export const specialIdentifiers = {
  InputProblemTypeIdentifier: "problemType",
  InputProblemDescriptioniIdentifier: "problemType",
  InputIDPersonalCodeIdentifier: "IDPersonalCode",
  InputIDFirstNameIdentifier: "firstName",
  InputIDLastNameIdentifier: "lastName",
  InputContactEmailIdentifier: "email",
  InputContactPhoneIdentifier: "phoneNumber",
  InputCategorieSesizareIdentifier: "CategorieSesizare",
  SectionGDPR: "GDPR",
  FormProblemReportIdentifier: "ReportMapProblem",
};

export const citizenInfoIdentifiers = {
  IDFirstName: "IDFirstName",
  IDLastName: "IDLastName",
  IDPersonalCode: "IDPersonalCode",
  IDDocumentSeries: "IDDocumentSeries",
  IDDocumentNumber: "IDDocumentNumber",
};

export const citizenInfoUserKeys: Record<keyof typeof citizenInfoIdentifiers, string> = {
  IDFirstName: "firstName",
  IDLastName: "lastName",
  IDPersonalCode: "personalCode",
  IDDocumentSeries: "identityCard.series",
  IDDocumentNumber: "identityCard.number",
};

export const citizenDigitalIdentityIdentifiersMap = {
  firstName: "firstName",
  lastName: "lastName",
  personalCode: "personalCode",
  nationality: "nationality",
  gender: "gender",
  birthDate: "birthDate",
  birthPlace: "birthPlace",
  phoneNumber: "phoneNumber",
  series: "identityCard.series",
  number: "identityCard.number",
  issuedBy: "identityCard.issuedBy",
  validFrom: "identityCard.validFrom",
  validUntil: "identityCard.validUntil",
};
